import { Box } from "@mui/material";
import { PuffLoader } from "react-spinners";
import "./Spinner.css";

const Spinner = ({ loading }) => {
	return (
		<Box className="spinnerContainer">
			<PuffLoader color="black" size={45} loading={loading} />
		</Box>
	);
};

export default Spinner;
